import { createSlice } from "@reduxjs/toolkit"
import { ApiStatus } from "../../types/api/status"
import { ProductEntry, productEntryType } from "../../types/slices/productEntryType"
import { RootState } from "../store"

const initialState: productEntryType = {
    status: ApiStatus.FETCHED,
    productEntrys: [],
    productEntrySelected: {} as ProductEntry,
    errorMessage: undefined
}

const productEntrySlice = createSlice({
    name: 'productEntrySlice',
    initialState,
    reducers: {
        onFetchProductEntrys(state, { payload }: { payload: ProductEntry[] }) {
            state.status = ApiStatus.FETCHED
            state.productEntrys = payload
            state.errorMessage = undefined
        },
        onSetSelectedProductEntry(state, { payload }: { payload: ProductEntry }) {
            state.productEntrySelected = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        }
    }
})

export const selectProductEntryState = (state: RootState) => state.productEntrySlice
export default productEntrySlice.reducer
export const {
    onFetchProductEntrys,
    onSetSelectedProductEntry,
    changeStatus
} = productEntrySlice.actions